import AdminContentIndex from './Content';

export default AdminContentIndex;
